/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue";
import Toast from "vux/src/components/toast/index.vue";
import Loading from "vux/src/components/loading/index.vue";
export default {
  name: 'PositionCell',
  components: {
    Cell: Cell,
    Toast: Toast,
    Loading: Loading
  },
  props: {
    title: {
      type: String,
      default: '定位'
    },
    address: {
      type: Array,
      default: []
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      currAddress: this.address,
      longitude: '',
      latitude: '',
      loadingShow: false,
      hasTitleSlot: false
    };
  },
  computed: {
    currAddressForShow: function currAddressForShow() {
      if (this.currAddress && this.currAddress.length > 0 && this.currAddress[0] !== '') return this.currAddress[0];
      return '';
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    address: function address(val) {
      this.currAddress = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val, this.currAddress);
      this.$emit('input', val);
    }
  },
  methods: {
    position: function position() {
      var _this = this;

      try {
        this.loadingShow = true;
        this.$DingTalk.device.geolocation.get({
          targetAccuracy: 100,
          // 精度半径
          coordinate: 1,
          // 1 高德坐标 2 标准坐标（无address字段）
          withReGeocode: true,
          // 是否返回逆地理编码信息
          useCache: true,
          // 是否缓存（开启后2分钟内再次请求返回缓存信息）
          onSuccess: function onSuccess(_ref) {
            var longitude = _ref.longitude,
                latitude = _ref.latitude,
                address = _ref.address;
            _this.loadingShow = false;

            if (address && longitude && latitude) {
              _this.longitude = longitude;
              _this.latitude = latitude;
              _this.currAddress = address;
              _this.currValue = [longitude, latitude];
            } else {
              _this.$vux.toast.text('定位失败');
            }
          },
          onFail: function onFail(e) {
            _this.loadingShow = false;
            console.log('geolocation error');
          }
        });
      } catch (error) {
        this.$vux.toast.text('定位失败');
        this.loadingShow = false;
      }
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};